module.exports = __webpack_public_path__ + "assets/img/one.725463e2.jpg";